<template>
  <form class="contact-form-container col-md-6 col-sm-8 col-xs-12" @submit.prevent="validateBeforeSubmit(ContactUsForm.message)">
    <div class="row">
        <div class="input-field col-md-12 col-xs-12">
            <input name="fullName" v-validate="'required'" :class="{'is-danger': errors.has('fullName') }" type="text" v-model="ContactUsForm.message.fullName">
            <label for="fullName">{{ $t("form.fullName") }}</label>
            <span v-show="errors.has('fullName')" class="help is-danger">{{ errors.first('fullName') }}</span>
        </div>
    </div>
    <div class="row">
        <div class="input-field col-md-12 col-xs-12">
            <input v-validate="'required|email'" :class="{'is-danger': errors.has('email') }" name="email" type="email" v-model="ContactUsForm.message.email">
            <label for="email">{{ $t("form.emailAddress") }}</label>
            <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
        </div>
    </div>
    <div class="row m-b-20 m-t-20">
        <div class="col-md-12 col-xs-12">
            <h6 class="m-b-20">{{ $t("form.yourReferal") }}</h6>
            <input v-validate="'required'" v-model="referalSource" value="Google Search" name="referal" type="radio" id="google" />
            <label for="google">{{ $t("referal.google") }}</label>
            <input v-validate="'required'" data-vv-as="Referal Source" v-model="referalSource" value="Social Media: Twitter, LinkedIn" name="referal" type="radio" id="social" />
            <label for="social">{{ $t("referal.social") }}</label>
            <input v-validate="'required'" data-vv-as="Referal Source" v-model="referalSource" value="A Friend" name="referal" type="radio" id="friend" />
            <label for="friend">{{ $t("referal.friend") }}</label>
            <input v-validate="'required'" data-vv-as="Referal Source" v-model="referalSource" value="Other" name="referal" type="radio" id="other" />
            <label for="other">{{ $t("referal.other") }}</label>
            <span v-show="errors.has('referal')" class="help is-danger">{{ errors.first('referal') }}</span>
        </div>
    </div>
    <div class="row">
        <div class="input-field col-md-12 col-xs-12">
            <textarea v-validate="'required'" :class="{'is-danger': errors.has('message') }" name="message" class="materialize-textarea" v-model="ContactUsForm.message.messageContent"></textarea>
            <label for="textarea1">{{ $t("form.message") }}</label>
            <span v-show="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</span>
        </div>
    </div>
    <div class="row end-md buttonContainer xs-block">
        <button type="submit" class="button button--primary dsButtonAnim" v-bind:class="{ loading: contactMessageRequest}">
            <span class="button--primary__text">{{ $t("form.sendYourMessage") }}</span>
        </button>
    </div>
    <div class="row m-b-20 m-t-20">
        <span class="help is-danger" v-show="messageSendingError">{{ $t("form.messageSendingError") }}</span>
        <span class="help is-success" v-show="messageSendingSuccess">{{ $t("form.messageSendingSuccess") }}</span>
    </div>
  </form>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import materialize from "materialize-css";
import arabicValidate from "vee-validate/dist/locale/ar";
import englishValidate from "vee-validate/dist/locale/en";

Object.defineProperty(Vue.prototype, "$materialize", { value: materialize });

Vue.use(VeeValidate);

export default {
  name: "ContactForm",
  props: [
    "FormName",
    "ProjectEstimation",
    "ReferalSource",
    "StartTime",
    "UserSelectedOptions"
  ],
  data() {
    return {
      estimationForm: false,
      contactMessageRequest: false,
      messageSendingError: false,
      messageSendingSuccess: false,
      disabledForm: true,
      endTime: 0,
      referalSource: "",
      ContactUsForm: {
        message: {
          fullName: "",
          email: "",
          messageContent: ""
        }
      }
    };
  },
  mounted() {
    if (this.FormName === "get-an-estimation") {
      this.estimationForm = true;
    }
    if (this.$i18n.locale === "ar") {
      this.$validator.localize("ar", {
        messages: arabicValidate.messages,
        attributes: {
          fullName: "الاسم بالكامل",
          email: "البريد الالكتروني",
          referal: "المصدر",
          message: "نص الرسالة"
        }
      });
    } else {
      this.$validator.localize("en", {
        messages: englishValidate.messages
      });
    }
  },
  methods: {
    millisToMinutesAndSeconds(millis) {
      var minutes = Math.floor(millis / 60000);
      var seconds = ((millis % 60000) / 1000).toFixed(0);
      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    },
    validateBeforeSubmit(message) {
      const _self = this;
      this.$validator.validateAll().then(function(result) {
        if (result) {
          _self.sendMessage(message);
        }
      });
    },
    sendMessage(message) {
      this.contactMessageRequest = true;
      var url = this.$parent.$parent.$parent.apiURL + "/contactuses/submit";
      let _self = this;

      if (this.estimationForm) {
        var endTime = new Date();
        var timeToFinish = endTime - this.StartTime;
        var timeSpent = this.millisToMinutesAndSeconds(timeToFinish);
        var selectedOptions = "";

        this.UserSelectedOptions.forEach(function(option) {
          var selectedOptionsTitle = "";
          option.selectedOptionTitle.forEach(function(title) {
            selectedOptionsTitle += title + ", ";
          });
          selectedOptions += option.question + " : " + selectedOptionsTitle;
        });
        message["userSelectedOptions"] = selectedOptions;
        message["timeSpent"] = timeSpent;
        message["projectEstimation"] = _self.ProjectEstimation;
      }
      message["referalSource"] = this.referalSource;

      this.$http.post(url, { name: this.FormName, data: message }).then(
        function(response) {
          this.contactMessageRequest = false;
          this.messageSendingError = false;
          this.messageSendingSuccess = true;
        },
        function(error) {
          this.messageSendingError = true;
          this.messageSendingSuccess = false;
          this.contactMessageRequest = false;
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/ContactForm.vue